"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appSwitcherSections = exports.rightNavigationItems = exports.leftNavigationItems = exports.navigationItems = exports.iconSize = exports.icons = void 0;
var AppSwitcher_1 = __importDefault(require("@acl-services/wasabicons/lib/AppSwitcher"));
var HelpCircle_1 = __importDefault(require("@acl-services/wasabicons/lib/HelpCircle"));
var AclLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/AclLogo"));
var UserCircle_1 = __importDefault(require("@acl-services/wasabicons/lib/UserCircle"));
var Academy_1 = __importDefault(require("@acl-services/wasabicons/lib/Academy"));
var CommunityLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/CommunityLogo"));
var LaunchpadLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/LaunchpadLogo"));
var MissionControl_1 = __importDefault(require("@acl-services/wasabicons/lib/MissionControl"));
var ProjectsLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/ProjectsLogo"));
var ReportsLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/ReportsLogo"));
var ResultsLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/ResultsLogo"));
var Robot_1 = __importDefault(require("@acl-services/wasabicons/lib/Robot"));
var StrategyLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/StrategyLogo"));
var Keyboard_1 = __importDefault(require("@acl-services/wasabicons/lib/Keyboard"));
exports.icons = {
    appSwitcher: AppSwitcher_1.default,
    helper: HelpCircle_1.default,
    logo: AclLogo_1.default,
    user: UserCircle_1.default,
    keyboardShortcutPanel: Keyboard_1.default,
    academy: Academy_1.default,
    community: CommunityLogo_1.default,
    launchpad: LaunchpadLogo_1.default,
    mission_control: MissionControl_1.default,
    projects: ProjectsLogo_1.default,
    reports: ReportsLogo_1.default,
    results: ResultsLogo_1.default,
    robots: Robot_1.default,
    risks: StrategyLogo_1.default,
};
exports.iconSize = '20px';
exports.navigationItems = {
    currentApp: 'CURRENT_APP',
    appSwitcher: 'APP_SWITCHER',
    helper: 'HELPER',
    helperWithPendo: 'HELPER_WITH_PENDO',
    logo: 'LOGO',
    launchpadLink: 'LAUNCHPAD_LINK',
    user: 'USER',
    signIn: 'SIGN_IN',
    keyboardShortcutPanel: 'KEYBOARD_SHORTCUT_PANEL',
};
exports.leftNavigationItems = [
    exports.navigationItems.logo,
    exports.navigationItems.appSwitcher,
    exports.navigationItems.currentApp,
    exports.navigationItems.launchpadLink,
];
exports.rightNavigationItems = [
    exports.navigationItems.signIn,
    exports.navigationItems.helper,
    exports.navigationItems.helperWithPendo,
    exports.navigationItems.user,
    exports.navigationItems.keyboardShortcutPanel,
];
exports.appSwitcherSections = {
    appLink: 'APP_LINK',
    resourceLink: 'RESOURCE_LINK',
};
//# sourceMappingURL=constants.js.map